var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{attrs:{"id":"player-container-id","preload":"auto","playsinline":"","webkit-playsinline":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }